// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { GAMES } from '../data';
import Logo from './Logo';
import { InstallButton, HomepageButton, PlayStoreButton, ZARSALLA_URL } from './AppLinks';

export default function Footer() {
  const half = Math.ceil(GAMES.length / 2);
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Logo sub="Kart Oyunları" />
            <p>
              Oyuntu; Pişti, Batak, 51, King, Kanasta ve daha fazlasını tarayıcıda oynayabileceğin, arkadaşlarınla buluşabileceğin Türkçe kart oyunları platformudur. Sürekli yeni oyunlar ve özellikler ekleniyor.
            </p>
            <div className="footer-apps">
              <InstallButton />
              <HomepageButton />
            </div>
          </div>
          <div>
            <h2>Oyunlar</h2>
            <ul>
              {GAMES.slice(0, half).map((g) => (
                <li key={g.id}><Link to={`/oyun/${g.id}`}>{g.name} oyna</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h2>Daha fazla</h2>
            <ul>
              {GAMES.slice(half).map((g) => (
                <li key={g.id}><Link to={`/oyun/${g.id}`}>{g.name} oyna</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h2>Oyuntu</h2>
            <ul>
              <li><Link to="/rehber">Oyun rehberleri</Link></li>
              <li><Link to="/lider-tablosu">Lider tabloları</Link></li>
              <li><Link to="/oyuntu/hakkimizda">Hakkımızda</Link></li>
              <li><Link to="/oyuntu/iletisim">İletişim</Link></li>
              <li><Link to="/oyuntu/gizlilik">Gizlilik ve çerezler</Link></li>
              <li><a href="https://oyuntreni.com.tr" target="_blank" rel="noopener noreferrer">Oyun Treni ↗</a></li>
              <li><a href={ZARSALLA_URL} target="_blank" rel="noopener noreferrer">Zar Salla ↗</a></li>
            </ul>
            <PlayStoreButton />
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} Oyuntu. Tüm hakları saklıdır.</span>
          <span>Oyunlar gerçek parayla oynanmaz. <Link to="/oyuntu/gizlilik">Gizlilik Politikası</Link></span>
        </div>
      </div>
    </footer>
  );
}
